// extracted by mini-css-extract-plugin
module.exports = {"button":"LabibaTrigger_button__Gbasd"};